/**
 * LaptopSkinKeyRegistry is a generic object which functions as sort of a dictionary, for storing laptop SkinKey objects.
 * @see AbstractInstaller._mapMediator
 * @type {Object} 
 */
const LaptopSkinKeyRegistry = {};
export default LaptopSkinKeyRegistry;